import { useFieldArray, useFormContext } from 'react-hook-form'

import { PageSection, PageSectionFace } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { emptySAR } from '../../../../../../../constants'
import { TransactionInfo } from './TransactionInfo'

export const TransactionsInfo = () => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `transactionsInfo`
  })

  return (
    <PageSection face={PageSectionFace.THIRD} title="Transactions Information" anchor="transactions-info">
      {fields.map((field, index) => (
        <TransactionInfo key={field.id} index={index} total={fields.length} onDelete={remove} />
      ))}
      <FormRow>
        <Button
          face="primary"
          onClick={() => {
            append(emptySAR.transactionsInfo[0])
          }}
        >
          Add
        </Button>
      </FormRow>
    </PageSection>
  )
}
